// packages block
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import React, { useEffect, useState, useRef } from "react";
import { Popper, Paper, Grow, ClickAwayListener, MenuItem, MenuList, Avatar, Box, Typography } from "@material-ui/core";
// common block
import "./style.css";
import { DetailTabs } from "./components/detailTabs";
import { BackButton } from "../../components/backButton";
import { useStyles } from "../../components/managementTable/styles";
// constants, theme, utils and api block
import { setAlert } from "../../redux/reducers/alert";
import { PrimaryBackgroundColor } from "../../styles/colors";
import { deleteSchool, getSchoolById } from "../../api/schools";
import { useHistory } from "react-router";
import { AddSchoolDialog } from "../../components/dialogs";

export const SchoolDetail = (props) => {
  const [isEditText, setIsEditText] = useState("");
  const [open, setOpen] = useState(false);
  const [isAddSchoolDialogVisible, setIsAddSchoolDialogVisible] =
    useState(false);
  const [isEditedItem, setIsEditedItem] = useState(null);
  const anchorRef = useRef(null);
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory()
  const { t } = useTranslation();

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const user = useSelector((state) => state.user);

  const schoolId =
    props && props.match && props.match.params && props.match.params.schoolId;

  const [schoolData, setSchoolData] = useState([]);
  const { token } = useSelector((state) => state.user);

  const schoolDelete = async () => {
    try {
      await deleteSchool(schoolId, token);
      showSuccessAlert(t("text_school_deleted_successfully"));
      history.push("/schools")
    } catch (err) {
      showErrorAlert(
        err.message || t("text_error_in_deleting_school_please_try_again")
      );
    }
  };

  const editSchoolDetail = () => {
    setIsAddSchoolDialogVisible(true);
  };

  const closeAddUserDialog = () => {
    setIsAddSchoolDialogVisible(false);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };

  const fetchSchool = async () => {
    try {
      const response = await getSchoolById(schoolId, token);
      if (!response.status) {
        showErrorAlert(response?.message || t("text_error_in_fetching_school_detail"));
        return;
      }

      setIsEditedItem(response?.school);
      setSchoolData(response?.school)
    } catch (err) {
      showErrorAlert(err.message || t("text_error_in_fetching_school_detail"));
    }
  };

  const editCallback = (text) => {
    setIsEditText(text);
  };

  useEffect(() => {
    if (schoolId) {
      fetchSchool();
    }
  }, []);

  return (
    <>
      <Typography variant="h4" style={{ color: "black", fontWeight: "bold", flex: 1, paddingBottom: "10px", marginBottom: 20 }}>
        {t("text_school_details")}
      </Typography>

      <div className="school-management-page school-details-row">
        <div className="transaction-detail-container user-details-col1" >
          <div style={{ padding: '20px 60px 0px 20px', display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <BackButton />

            <Box display="flex" flexDirection="row" maxWidth="13vw" width="100%" justifyContent="flex-end" alignItems="center">
              <div
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                role="presentation"
                className={classes.actionButton}
              >
                <MoreHorizIcon />
              </div>
            </Box>

            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: "1" }}>
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList id="menu-list-grow" onKeyDown={handleListKeyDown}>
                        <MenuItem style={{ color: "black", fontWeight: "bold", fontSize: "12px" }} onClick={editSchoolDetail}>{t("text_edit_school")}</MenuItem>
                        <MenuItem style={{ color: "black", fontWeight: "bold", fontSize: "12px" }} onClick={schoolDelete}>{t("text_delete_school")}</MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>

          <div
            style={{
              padding: "20px 60px",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex" }}>
              <Avatar
                style={{
                  height: 60,
                  width: 60,
                  backgroundColor: PrimaryBackgroundColor,
                }}
              />

              <div style={{ padding: "0px 20px" }}>
                <div
                  style={{
                    color: PrimaryBackgroundColor,
                    fontWeight: "500",
                    textTransform: "capitalize",
                  }}
                >
                  {schoolData?.name ? schoolData.name : ""}
                </div>
              </div>
            </div>
          </div>
          <DetailTabs school={schoolData} />
        </div>

        {
          isAddSchoolDialogVisible && (
            <AddSchoolDialog
              title={t("text_edit_school")}
              handleClose={closeAddUserDialog}
              open={isAddSchoolDialogVisible}
              editCallback={editCallback}
              successCallback={
                () => history.push("/schools")
              }
              isEditedItem={isEditedItem}
              user={user}
              showCircularProgressBar={true}
            />
          )
        }
      </div>
    </>
  );
};
